import React from "react";
import AllocatePropertyModal from "./AllocatePropertyModal";

const AllocateProperty = ({ show, cp_id, handleClose }) => (
  <AllocatePropertyModal
    show={show}
    cp_id={cp_id}
    handleClose={handleClose}
    persistOnSave
  />
);

export default AllocateProperty;
